<template>
  <div class="titan-password-field">
    <font-awesome-icon
      :icon="visible ? 'eye-slash' : 'eye'"
      class="eye-icon"
      @click="visible = !visible"
    />
    <input
      :type="visible ? 'text' : 'password'"
      v-model="value"
      class="form-control"
    />
  </div>
</template>
<script>
import { abstractField } from "vue-form-generator";

export default {
  name: "FormPassword",
  mixins: [abstractField],
  data() {
    return {
      visible: false
    };
  }
};
</script>
<style lang="scss">
.titan-password-field {
  position: relative;
  width: 100%;

  .eye-icon {
    position: absolute;
    right: 10px;
    z-index: 10;
    top: 12px;
    cursor: pointer;
    opacity: 0.5;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently supported */
  }
}
</style>
